module.exports = __webpack_public_path__ + "roboto-mono-latin-ext-700-normal.woff2";